import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Input, InputRef, Typography } from 'antd'
import { useIntl } from 'react-intl'

import IntlMessages from '../../../../util/IntlMessages'

const { Paragraph, Link } = Typography

export interface IEmailStepProps {
  email: string
  isBusy: boolean
  onSubmit: (email: string) => void
  onEmailChanged: (email: string) => void
  onSignUp: () => void
}

const EmailStep = ({ email, isBusy, onSubmit, onEmailChanged, onSignUp }: IEmailStepProps): React.ReactElement => {
  const { formatMessage } = useIntl()
  const [form] = Form.useForm()
  const inputRef = useRef<InputRef | null>(null)
  const [hasTyped, setHasTyped] = useState(false)

  useEffect(() => {
    form.setFieldsValue({ email })
  }, [email])

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <>
      <Paragraph className="connect-with-email">
        <IntlMessages id="app.email" />
      </Paragraph>
      <Form
        name="connect-with-email"
        form={form}
        layout="horizontal"
        initialValues={{ email }}
        onFinish={(values) => onSubmit(values.email)}
        onFieldsChange={() => onEmailChanged(form.getFieldValue('email') ?? '')}
      >
        <Form.Item
          name="email"
          style={{ width: '100%' }}
          // Half a typed address is not a wrong one, and an untouched field is not one either.
          // Ant validates on change by default, and this field takes focus on arrival, so a
          // click anywhere else would scold a visitor who never typed a character.
          validateTrigger={hasTyped ? 'onBlur' : []}
          rules={[{ required: true, type: 'email', message: <IntlMessages id="connect.pleaseInputValidEmail" /> }]}
        >
          <Input
            className="email-input data-hj-allow"
            size="large"
            data-qa="email-login-mail"
            placeholder={formatMessage({ id: 'app.enterWorkEmail' })}
            ref={inputRef}
            onChange={() => setHasTyped(true)}
          />
        </Form.Item>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" disabled={isBusy} loading={isBusy} data-qa="email-login-submit" block>
            <IntlMessages id="app.continue" />
          </Button>
        </Form.Item>
      </Form>
      <Paragraph className="auth-sidebar-login">
        <IntlMessages id="connect.dontHaveAnAccount" />
        &nbsp;
        <Link onClick={onSignUp} data-qa="signin-signup-link">
          <IntlMessages id="user.signUp" />
        </Link>
      </Paragraph>
    </>
  )
}

export default EmailStep
